import { render } from "./InstagramRedirectView.vue?vue&type=template&id=94be2a48&scoped=true"
import script from "./InstagramRedirectView.vue?vue&type=script&lang=js"
export * from "./InstagramRedirectView.vue?vue&type=script&lang=js"

import "./InstagramRedirectView.vue?vue&type=style&index=0&id=94be2a48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94be2a48"]])

export default __exports__